function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Instellingen",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instellingen-/-Werkplektype-stiltewerkplek-Copy",
  transform: "translate(-670.000000, -518.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "popup",
  transform: "translate(476.000000, 370.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Geen-resultaten",
  transform: "translate(194.000000, 148.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "verwijder-popup-iccon"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#F6F6F6",
  cx: 50,
  cy: 50,
  r: 50
}), /*#__PURE__*/React.createElement("g", {
  id: "Delete",
  transform: "translate(32.000000, 32.000000)",
  stroke: "#485156",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("g", {
  id: "bin-1",
  transform: "translate(0.006369, 0.006369)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.0227273,6.23106061 L28.3001515,32.0880177 C28.139486,33.6170708 26.850602,34.7782334 25.3131313,34.7790404 L9.68686869,34.7790404 C8.14882331,34.7790404 6.8590717,33.6176421 6.69834596,32.0880177 L3.97727273,6.23106061",
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0.220959596,
  y1: 6.23106061,
  x2: 34.7790404,
  y2: 6.23106061,
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.7386364,6.23106061 L10.7386364,1.72348485 C10.7386364,0.893663065 11.4113398,0.220959596 12.2411616,0.220959596 L22.7588384,0.220959596 C23.5886602,0.220959596 24.2613636,0.893663065 24.2613636,1.72348485 L24.2613636,6.23106061",
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.5,
  y1: 12.9924242,
  x2: 17.5,
  y2: 28.7689394,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 24.2613636,
  y1: 12.9924242,
  x2: 23.510101,
  y2: 28.7689394,
  id: "Shape"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.7386364,
  y1: 12.9924242,
  x2: 11.489899,
  y2: 28.7689394,
  id: "Shape"
}))))))));
function SvgDeleteLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "verwijder popup iccon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLarge);
export default __webpack_public_path__ + "static/media/Delete_Large.28b5c52556ea78d31d22ec96a152da58.svg";
export { ForwardRef as ReactComponent };